import 'hammerjs';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material';
import { MatCheckboxModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatSnackBarModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from 'app/app.component';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import { FormComponent } from 'app/modules/auth/request/import/form/form.component';
import { storageSyncMetaReducer } from 'ngrx-store-persist';
import { AppRoutingModule } from './app-routing.module';
import { LoadingModule } from './shared/components/several-components/loading/loading.module';
import { rootReducer } from './store/index.reducers';
import { ChartsModule } from 'ng2-charts';
import {ConnectionServiceModule, ConnectionServiceOptions, ConnectionServiceOptionsToken} from 'ngx-connection-service';


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot(),
        MatSnackBarModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        MatInputModule,
        ChartsModule,
        ConnectionServiceModule,

        // Material moment date module
        MatMomentDateModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // NgRx
        StoreModule.forRoot(rootReducer, { metaReducers: [storageSyncMetaReducer]}),
        StoreDevtoolsModule.instrument({maxAge: 25}),

        // App modules
        LayoutModule,
        LoadingModule,
    ],
    bootstrap: [
        AppComponent,
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        FormComponent,
        {
          provide: ConnectionServiceOptionsToken,
          useValue: {
            enableHeartbeat: false,
            heartbeatUrl: '/assets/ping.json',
            requestMethod: 'get',
            heartbeatInterval: 3000
          } as ConnectionServiceOptions
        }
      ],
})
export class AppModule {
}
